export default "__VITE_ASSET__BViP1ZEC__"